import { LangCode } from "../types/lang";

export const LANG = {
    [LangCode.en]: {
        label: 'English',
        link: import.meta.env.VITE_LANG_URL_EN,
        img_flag: 'https://itov3-test.s3.ap-southeast-1.amazonaws.com/language-eng.png'
    },
    [LangCode.vi]: {
        label: 'Vietnamese',
        link: import.meta.env.VITE_LANG_URL_VI,
        img_flag: 'https://itov3-test.s3.ap-southeast-1.amazonaws.com/language-vn.png'
    },
}